webpackJsonp([246384609461072],{

/***/ 49:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.HeaderBG = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyImage = __webpack_require__(13);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _cloud_texture = __webpack_require__(69);
	
	var _cloud_texture2 = _interopRequireDefault(_cloud_texture);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HalfScreenParallaxHero = function HalfScreenParallaxHero(_ref) {
	  var title = _ref.title,
	      bg = _ref.bg,
	      symbol = _ref.symbol;
	
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      "section",
	      {
	        className: "page-title parallax13 parallax-fix page-title-large",
	        style: {
	          background: "url(" + bg + ") 50% 0px",
	          height: "50vh"
	        }
	      },
	      _react2.default.createElement(
	        "div",
	        { className: "titleContainer" },
	        _react2.default.createElement(
	          "div",
	          { className: "animated fadeInUp" },
	          _react2.default.createElement("div", { className: "separator-line bg-yellow no-margin-top margin-five" }),
	          _react2.default.createElement(
	            "h1",
	            { className: "white-text" },
	            title
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "no-margin-top content-section" },
	      _react2.default.createElement(
	        "div",
	        { className: "extra-texture" },
	        _react2.default.createElement("img", { src: _cloud_texture2.default, style: { width: "100%" } }),
	        _react2.default.createElement("img", { className: "symbol", src: symbol })
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "text-center heading no-padding overflow-hidden" },
	      _react2.default.createElement(
	        "h1",
	        { className: "white-text" },
	        title
	      )
	    )
	  );
	};
	
	exports.default = HalfScreenParallaxHero;
	var HeaderBG = exports.HeaderBG = "** extracted graphql fragment **";

/***/ }),

/***/ 249:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n      color: red;\n      &&:hover .gallery-img {\n        background-image: url(", ");\n      }\n    "], ["\n      color: red;\n      &&:hover .gallery-img {\n        background-image: url(", ");\n      }\n    "]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(16);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(7);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _orange_symbol = __webpack_require__(48);
	
	var _orange_symbol2 = _interopRequireDefault(_orange_symbol);
	
	var _gatsbyImage = __webpack_require__(13);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProjectThumbnail = function (_Component) {
	  _inherits(ProjectThumbnail, _Component);
	
	  function ProjectThumbnail() {
	    _classCallCheck(this, ProjectThumbnail);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  ProjectThumbnail.prototype.render = function render() {
	    var _props = this.props,
	        image = _props.image,
	        name = _props.name,
	        tags = _props.tags,
	        link = _props.link,
	        tagMap = _props.tagMap,
	        BG = _props.BG,
	        hoverImg = _props.hoverImg;
	
	    var formattedTags = tagMap.filter(function (a) {
	      return tags.indexOf(a.node.name) >= 0;
	    }).map(function (a) {
	      return a.node.name;
	    }).join(" | ");
	
	    var Figure = _styledComponents2.default.figure(_templateObject, hoverImg.resolutions.src);
	
	    return _react2.default.createElement(
	      "li",
	      null,
	      _react2.default.createElement(
	        Figure,
	        null,
	        _react2.default.createElement(
	          "div",
	          { className: "gallery-img" },
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: "/projects/" + link },
	            _react2.default.createElement("img", { src: "" + (BG && BG.sizes.src) })
	          )
	        ),
	        _react2.default.createElement(
	          "figcaption",
	          null,
	          _react2.default.createElement(
	            "h3",
	            null,
	            _react2.default.createElement("img", { src: _orange_symbol2.default }),
	            name
	          ),
	          _react2.default.createElement(
	            "p",
	            null,
	            formattedTags
	          )
	        )
	      )
	    );
	  };
	
	  return ProjectThumbnail;
	}(_react.Component);
	
	exports.default = ProjectThumbnail;
	module.exports = exports["default"];

/***/ }),

/***/ 69:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/cloud_texture.01af96b4.png";

/***/ }),

/***/ 255:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(26);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _HalfScreenParallaxHero = __webpack_require__(49);
	
	var _HalfScreenParallaxHero2 = _interopRequireDefault(_HalfScreenParallaxHero);
	
	var _ParallaxDivider = __webpack_require__(51);
	
	var _ParallaxDivider2 = _interopRequireDefault(_ParallaxDivider);
	
	var _ProjectThumbnail = __webpack_require__(249);
	
	var _ProjectThumbnail2 = _interopRequireDefault(_ProjectThumbnail);
	
	var _NextPageSection = __webpack_require__(71);
	
	var _NextPageSection2 = _interopRequireDefault(_NextPageSection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var portfolioPage = function (_React$Component) {
	  _inherits(portfolioPage, _React$Component);
	
	  function portfolioPage() {
	    _classCallCheck(this, portfolioPage);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  portfolioPage.prototype.render = function render() {
	    var _this2 = this;
	
	    var dataql = this.props.data;
	    var acf = this.props.data.wordpressPage.acf;
	    var posts = this.props.data.allWordpressWpMbProject.edges;
	
	    console.log(posts.map(function (a) {
	      return a.node.tags;
	    }));
	
	    return _react2.default.createElement(
	      "div",
	      { className: "wow fadeIn", style: { visibility: "hidden" } },
	      _react2.default.createElement(_reactHelmet2.default, { title: "Portfolio | Moon Beyond Co" }),
	      _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(_HalfScreenParallaxHero2.default, {
	          title: acf.title,
	          bg: acf.background_image.localFile.childImageSharp.resolutions.src,
	          symbol: acf.symbol.localFile.childImageSharp.sizes.src
	        }),
	        _react2.default.createElement(
	          "div",
	          { className: "work-3col gutter no-margin-top content-section" },
	          _react2.default.createElement(
	            "div",
	            { className: "container" },
	            _react2.default.createElement(
	              "div",
	              { className: "row" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-12 text-center" },
	                _react2.default.createElement("div", { className: true })
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-12 grid-gallery overflow-hidden" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "tab-content" },
	                  _react2.default.createElement(
	                    "ul",
	                    { className: "grid masonry-items" },
	                    posts.sort(function (a, b) {
	                      return a.node.menu_order > b.node.menu_order ? 1 : -1;
	                    }).map(function (a, i) {
	                      return _react2.default.createElement(_ProjectThumbnail2.default, {
	                        key: i,
	                        name: a.node.acf.project_title,
	                        tags: a.node.tags ? a.node.tags.map(function (tag) {
	                          return tag.name;
	                        }) : [""],
	                        link: a.node.slug,
	                        tagMap: _this2.props.data.allWordpressTag.edges,
	                        hoverImg: dataql.thumbBG,
	                        BG: a.node.acf.thumbnail && a.node.acf.thumbnail.localFile.childImageSharp
	                      });
	                    })
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "section",
	          { className: "new-project no-padding-top" },
	          _react2.default.createElement(
	            "div",
	            { className: "container" },
	            _react2.default.createElement(
	              "div",
	              { className: "row center-col text-center wow fadeInUp" },
	              _react2.default.createElement(_NextPageSection2.default, { blurb: acf.next_page_blurb, to: "contact", linkText: acf.next_page_button_text, black: true })
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return portfolioPage;
	}(_react2.default.Component);
	
	exports.default = portfolioPage;
	var query = exports.query = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-portfolio-js-7d0c0a5d48561a9816ca.js